// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3 2H11.4142L13.4142 4H21.4277L19.0641 10.5L21.4277 17H12.5858L10.5858 15H5V22.5H3V2Z"}}]};

const FlagFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'flag-filled',
    ref,
    icon: element,
  },
));

FlagFilledIcon.displayName = 'FlagFilledIcon';

export default FlagFilledIcon;
